import { css } from "@emotion/react";

export const spansTableCSS = css`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow: hidden;
  .span-filter-condition-field {
    flex: 1 1 auto;
  }

  // Style the column selector
  .dropdown__button {
    min-width: var(--global-dimension-static-size-300);
  }

  /* Machi, PII Alert style inga dhaan irukku 🎨 */
  tr[data-pii="true"] {
    background-color: #fffbeb !important; /* light yellow-50 */
    border-left: 3px solid var(--ac-global-color-warning) !important;
  }

  tr[data-pii="true"]:hover {
    background-color: #fef3c7 !important; /* light yellow-100 */
  }

  tr[data-pii="true"][data-selected="true"] {
    background-color: #fef3c7 !important;
  }

  tbody tr {
    height: 52px !important;
    max-height: 52px !important;
  }
`;

export const scrollbarCSS = css`
  scrollbar-width: thin;
  scrollbar-color: var(--ac-global-color-grey-300) transparent;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--ac-global-color-grey-300);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: var(--ac-global-color-grey-400);
  }
`;
